"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmSelector = void 0;
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
exports.SmSelector = (0, react_1.forwardRef)((_a, ref) => {
    var { label, srOnly = false, invalid = false, type = 'checkbox', labelClassname, message, className } = _a, props = __rest(_a, ["label", "srOnly", "invalid", "type", "labelClassname", "message", "className"]);
    const labelClassnames = (0, classnames_1.default)('c-selector__label', {
        '-disabled': props.disabled,
    }, labelClassname);
    const inputClassnames = (0, classnames_1.default)('c-selector__input', {
        '-error': invalid,
        'mr-3': !srOnly,
    }, `-${type}`, className);
    const innerType = react_1.default.useMemo(() => {
        if (type === 'radio') {
            return 'radio';
        }
        return 'checkbox';
    }, [type]);
    return (react_1.default.createElement("div", { className: "c-selector" },
        react_1.default.createElement("label", { className: labelClassnames },
            react_1.default.createElement("input", Object.assign({}, props, { className: inputClassnames, "aria-describedby": invalid && message && props.id ? `${props.id}-message` : '', ref: ref, "aria-invalid": invalid, type: innerType, "aria-label": srOnly ? label : props['aria-label'] })),
            !srOnly && label),
        type !== 'switch' && invalid && message && !props.disabled && (react_1.default.createElement("span", { id: props.id ? `${props.id}-message` : '', className: "c-selector__errorMessage", "aria-live": "polite" }, message))));
});
//# sourceMappingURL=index.js.map